import React from "react";
import { Logo, PoweredBy } from "./Header";

const Footer = ({ onGetStarted }) => (
  <footer className="border-t border-slate-100 bg-[#0B1F2A]" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
      <div className="flex flex-col items-start justify-between gap-10 md:flex-row">
        <div className="max-w-sm">
          <Logo className="h-9" />
          <PoweredBy light className="mt-2 ml-0.5" />
          <p className="mt-4 text-sm leading-relaxed text-white/70">
            Make big moves in a whole new way. Together, with DubbleUpp. Buy the home you want and
            pay only half the monthly payment.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#3CABDA]">Explore</p>
            <ul className="mt-4 space-y-2.5 text-sm text-white/80">
              <li><a href="#buyer-buyer" className="transition-colors duration-200 hover:text-white">Buyer + Buyer</a></li>
              <li><a href="#investor" className="transition-colors duration-200 hover:text-white">Buyer + Investor</a></li>
              <li><a href="#calculator" className="transition-colors duration-200 hover:text-white">Calculator</a></li>
              <li><a href="#agreement" className="transition-colors duration-200 hover:text-white">The Agreement</a></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#3CABDA]">Get Started</p>
            <ul className="mt-4 space-y-2.5 text-sm text-white/80">
              <li><a href="#how-it-works" className="transition-colors duration-200 hover:text-white">How It Works</a></li>
              <li>
                <button onClick={onGetStarted} className="transition-colors duration-200 hover:text-white">
                  Sign Up Today
                </button>
              </li>
              <li>
                <button onClick={onGetStarted} className="transition-colors duration-200 hover:text-white">
                  Become an Investor
                </button>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#3CABDA]">Contact</p>
            <ul className="mt-4 space-y-2.5 text-sm text-white/80">
              <li><a href="mailto:hello@dubbleupp.com" className="transition-colors duration-200 hover:text-white">hello@dubbleupp.com</a></li>
              <li>DubbleUpp™</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-12 border-t border-white/10 pt-6 text-xs leading-relaxed text-white/50">
        <p>
          © {new Date().getFullYear()} DubbleUpp™. Powered by CityWorth. All rights reserved. Estimates shown are for
          illustration only and are not a commitment to lend. Actual qualification depends on
          credit, rates, and lender review.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
